import React from 'react'

import ContactArea from './components/ContactArea'
import NewsletterArea from './components/NewsletterArea'
import CertsAndAppsArea from './components/CertsAndAppsArea'
import ServicesArea from './components/ServicesArea'
import LegalArea from './components/LegalArea'
import CheckoutArea from './components/CheckoutArea'
import CustomStyles from './components/CustomStyles'

import ELocale from '../../types/locales'

import { TTickerItem } from '../../types/tickers'

type TFooterProps = {
  isReduced: boolean
  tickers: TTickerItem[]
  locale: ELocale
}

const Footer: React.FC<TFooterProps> = (props) => {
  const { locale, tickers } = props

  const [isReduced, setIsReduced] = React.useState(props.isReduced)

  React.useEffect(() => {
    window.eev?.on('show-reduced-footer', () => {
      setIsReduced(true)
    })
    window.eev?.on('show-full-footer', () => {
      setIsReduced(false)
    })
  }, [])

  // the legalCopy will later be maintained in contentful
  const legalCopy =
    'Alle Rechte vorbehalten. *Alle Preise inkl. gesetzlicher MwSt., zzgl. Versandkosten. ' +
    additionalTickerText(tickers).join(' ')
  return (
    <>
      <CustomStyles />
      <footer className="mt-80 bg-white overflow-auto">
        {!isReduced && <ContactArea locale={locale} />}
        {!isReduced && <NewsletterArea locale={locale} />}
        {!isReduced && <CertsAndAppsArea locale={locale} />}
        {!isReduced && <ServicesArea locale={locale} />}
        {isReduced && <CheckoutArea locale={locale} tickers={tickers} />}
        <LegalArea locale={locale} copy={legalCopy} />
      </footer>
    </>
  )
}

const additionalTickerText = (tickers: TTickerItem[]): string[] => {
  return tickers
    .map((tickerItem) => {
      const indicator = tickerItem.footNoteIndicator || ''
      const footNoteText = tickerItem.footNoteText || ''
      return indicator + footNoteText
    })
    .filter(Boolean)
}

export { Footer as default, TFooterProps }
